var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({ref:"buttonEl",staticClass:"h-6 w-6 bg-black rounded-full",class:[
    _vm.active
      ? 'scale-125 cursor-grabbing'
      : 'transition-all duration-300 cursor-grab' ],attrs:{"type":"button"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.$emit('clicking', $event)},"touchstart":function($event){$event.stopPropagation();return _vm.$emit('clicking', $event)}}},'button',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }